import React from 'react';
import SelectorButton from './SelectorButton';

const SelectorButtonContainer = ({
	product,
	customTitle,
	isActive,
	onClick,
	isBackgroundMode,
	bannerTextColor,
}) => {
	return (
		<SelectorButton
			product={product}
			customTitle={customTitle} // Pass the custom title here
			selected={isActive}
			onClick={onClick}
			isBackgroundMode={isBackgroundMode}
			bannerTextColor={bannerTextColor}
		/>
	);
};

export default SelectorButtonContainer;
